import pendingPhotoVerification from '@/components/common/svg/assets/loader_rounded.json';
import LottieAnimation from '@/animations/LottieAnimation.tsx';

export const ProfilePhotosLoader = () => {
  return (
    <LottieAnimation
      width={70}
      height={70}
      animationData={pendingPhotoVerification}
      shouldAnimate
      loop
    />
  );
};

export default ProfilePhotosLoader;
